import { useAuthenticationStore } from 'src/stores/authentication';

import { InstanceAuthenticationConfiguration } from 'src/models/authentication';

export interface ProviderRequestTarget {
	headers: Record<string, string>;
	url: string;
}

export const providerRequestTarget = (targetUrl: string): ProviderRequestTarget => {
	const target = new URL(targetUrl);

	if (target.protocol !== 'https:') {
		return { headers: {}, url: targetUrl };
	}

	const activeInstanceAuthenticationConfiguration = useAuthenticationStore()
		.activeInstanceAuthenticationConfiguration as InstanceAuthenticationConfiguration | null;

	if (!activeInstanceAuthenticationConfiguration) {
		throw new Error('No active instance authentication configuration found');
	}

	return {
		headers: {
			'X-Target-Domain': target.host,
			'X-Target-Path': target.pathname,
		},
		url: `${activeInstanceAuthenticationConfiguration.url}/cors-proxy.php${target.search}`,
	};
};
